import { render } from "./SourceDocument.vue?vue&type=template&id=7037ac5b&scoped=true"
import script from "./SourceDocument.vue?vue&type=script&lang=js"
export * from "./SourceDocument.vue?vue&type=script&lang=js"

import "./SourceDocument.vue?vue&type=style&index=0&id=7037ac5b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7037ac5b"]])

export default __exports__